import { Box, Radio, Typography } from '@mui/material';
import React, { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LoanFormType } from '../../types';

type Props = {
  loanForm: UseFormReturn<LoanFormType, object>;
  isLoanLoading: boolean;
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const AmountKindForm: FC<Props> = ({ loanForm, isLoanLoading, onSave }) => {
  const { t } = useTranslation();
  const { control } = loanForm;
  return (
    <Box display="flex">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Controller
          control={control}
          name="amount_kind"
          render={({ field }) => (
            <Radio
              onChange={(e) => {
                e.stopPropagation();
                field.onChange('net');
              }}
              checked={field.value === 'net'}
              inputProps={{ 'aria-label': 'Radio A', }}
              disabled={isLoanLoading}
              onBlur={() => { onSave(); }}
            />
          )}
        />
        <Typography variant="body2">{t('loan:net')}</Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Controller
          control={control}
          name="amount_kind"
          render={({ field }) => (
            <Radio
              onChange={(e) => {
                e.stopPropagation();
                field.onChange('gross');
              }}
              checked={field.value === 'gross'}
              inputProps={{ 'aria-label': 'Radio A', }}
              disabled={isLoanLoading}
              onBlur={() => { onSave(); }}
            />
          )}
        />
        <Typography variant="body2">{t('loan:gross')}</Typography>
      </Box>
    </Box>
  );
};
